module.exports = __webpack_public_path__ + "static/img/18091010.05baba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/18091010.jpg
// module id = /Lav
// module chunks = 0